import { render, staticRenderFns } from "./TertiaireAdmin.vue?vue&type=template&id=7cd6305d&scoped=true&"
import script from "./TertiaireAdmin.vue?vue&type=script&lang=js&"
export * from "./TertiaireAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd6305d",
  null
  
)

export default component.exports